// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cIKrl","disabled":"styles_disabled__LJJUY","label":"styles_label__3oUpf","full":"styles_full__LPvfi","switch":"styles_switch__dvPFn"};